import { type AnaliticaPluginInterface } from '@stone-payments/analitica'
import { analiticaInstance } from 'shared/analitica'

enum EventName {
  TokenRefreshed = 'token-refreshed',
  SessionError = 'session-error'
}

const SCREEN = 'session'
const generalSettings = { owner: 'signin', product: 'session', project: 'stone' }

const toSessionError = (error: unknown, fallbackMessage: string): Error => {
  if (error instanceof Error) {
    if (error.message) return error

    const fallback = new Error(fallbackMessage)
    fallback.name = error.name
    fallback.stack = error.stack
    return fallback
  }

  const fallback = new Error(fallbackMessage)
  fallback.name = 'SessionError'
  return fallback
}

const datadogOnly = (plugins: AnaliticaPluginInterface[]) => plugins.filter(({ name }) => name !== 'AMPLITUDE')

export const coreEvents = analiticaInstance.eventFactory('Core', {
  authenticator: {
    /**
     * @analitica Quando há algum erro ao revalidar a sessão (técnico, apenas Datadog)
     */
    errorRevalidateSession: (rawError?: unknown) => {
      const error = toSessionError(rawError, 'Erro ao revalidar a sessão')

      return {
        label: EventName.SessionError,
        filterPlugins: datadogOnly,
        metadata: {
          ...generalSettings,
          screen: SCREEN,
          description: 'Erro ao revalidar a sessão',
          reference: 'revalidateSession',
          status: 'revalidateSessionFailed',
          error,
          errorInfo: { name: error.name, message: error.message }
        }
      }
    },
    /**
     * @analitica Quando não há refreshToken no cookie para revalidar a sessão (técnico, apenas Datadog)
     */
    errorRefreshToken: () => {
      const error = new Error('Sem refreshToken no cookie')
      error.name = 'MissingRefreshToken'

      return {
        label: EventName.SessionError,
        filterPlugins: datadogOnly,
        metadata: {
          ...generalSettings,
          screen: SCREEN,
          description: 'Sem refreshToken no cookie',
          reference: 'missingRefreshToken',
          status: 'missingRefreshToken',
          error,
          errorInfo: { name: error.name, message: error.message }
        }
      }
    },
    /**
     * @analitica Token renovado com sucesso (técnico, apenas Datadog)
     */
    tokenRefreshed: () => ({
      label: EventName.TokenRefreshed,
      filterPlugins: datadogOnly,
      metadata: {
        ...generalSettings,
        screen: SCREEN,
        description: 'Token renovado com sucesso via refresh token',
        reference: 'tokenRefreshed',
        status: 'success'
      }
    })
  }
})
